module.exports = __webpack_public_path__ + "static/media/handleBarMainImg.23909090.png";